import addDays from 'date-fns/addDays'
import subDays from 'date-fns/subDays'
import formatDate from 'date-fns/format'
import differenceInYears from 'date-fns/differenceInYears'
import differenceInDays from 'date-fns/differenceInDays'
import formatDistanceToNowStrict from 'date-fns/formatDistanceToNowStrict'
import config from 'app/config'

export const format = (date = null, format = config.DEFAULT_DATE_FORMAT) => {
    return date ? formatDate(new Date(date), format) : null
}

export const getExpiryDate = (date = null) => {
    return date ? format(addDays(new Date(date), 30)) : null
}

export const getExpiryDays = (date = null) => {
    return date ? differenceInDays(new Date(addDays(new Date(date), 30)), new Date()) : null
}

export const getAgeFromDob = (date = null) => {
    return date
        ? differenceInYears(new Date(format(new Date(), 'yyyy-MM-dd')), new Date(date))
        : null
}

export const utcToSystemTimezone = (date = null) => {
    const offset = new Date().getTimezoneOffset()
    return date ? new Date(new Date(date).valueOf() - offset * 60 * 1000) : null
}

export const secondsToHMS = seconds => {
    if (isNaN(seconds)) return '00:00'
    else if (seconds >= 3600) return new Date(seconds * 1000).toISOString()?.substr(12, 7)
    else return new Date(seconds * 1000).toISOString()?.substr(14, 5)
}

export const formatDistanceStrict = (date = null) => {
    return date ? formatDistanceToNowStrict(new Date(date)) : null
}

export const dateTimeToTime = (date = null) => {
    return date ? format(date, 'HH:mm') : null
}

export const getDateRange = (duration = null, format = 'MM-dd-yyyy') => {
    if (!duration) return
    const range = {
        today: formatDate(new Date(), format),
        yesterday: formatDate(subDays(new Date(), 1), format),
        last7: [formatDate(subDays(new Date(), 6), format), formatDate(new Date(), format)],
        last30: [formatDate(subDays(new Date(), 29), format), formatDate(new Date(), format)],
    }
    return range[duration]
}
